export default __webpack_public_path__ + "static/media/raro-ajuda.28ecbee8.webp";